import { clientApi } from 'shared/api/clientApi'
import {
  DestinationFeedItem,
  IPromoTour,
  LastTourDocumentsResponse,
} from 'shared/api/tours/main-page/model.ts'
import { Response } from 'shared/models/general'

export const MainPageTours = {
  getPromoList() {
    return clientApi.get<Response<IPromoTour[]>>('ads/baners?page=TOURS')
  },

  getDestinationFeed(signal?: AbortSignal) {
    return clientApi.get<Response<DestinationFeedItem[]>>(
      'tours/destination-feed',
      { signal },
    )
  },

  getLastTourDocuments(signal?: AbortSignal) {
    return clientApi.get<Response<LastTourDocumentsResponse>>(
      'tours/appeal-last/v2',
      { signal },
    )
  },
}
